import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import api from './enhancedApiService'

export function trackPageView(path, referrer = document.referrer) {
  const metadata = {
    url: window.location.origin + path,
    path,
    referrer: referrer || undefined,
    title: document.title
  }
  // Analytics must never block navigation or show errors to user
  api.post('/analytics/ingest', { eventType: 'PAGE_VIEW', metadata }).catch(() => {
    // Silently ignore analytics errors (e.g., pending account approval)
  })
}

export function useRoutePageViews() {
  const location = useLocation()
  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])
}
